import * as io from 'io-ts'
import { makeGetBudgetFlowNodeDecoder } from './decoder'
import { makeSetBudgetFlowNodeEncoder } from './encoder'

export const nodes = {
  'budget-flow-store': {
    makeDecoder: makeGetBudgetFlowNodeDecoder,
    makeEncoder: makeSetBudgetFlowNodeEncoder,
  },
}

export type TNode = keyof typeof nodes

export type TGetNodeValue<P extends TNode> = io.TypeOf<ReturnType<typeof nodes[P]['makeDecoder']>>
